module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_7016.29c2651f.png";